import { render } from "./Pensum.vue?vue&type=template&id=ebd0330a"
import script from "./Pensum.vue?vue&type=script&lang=js"
export * from "./Pensum.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__